import React, { FC } from 'react'

import { Radio, RadioChangeEvent } from 'antd'
import styled from 'styled-components'

import { PrimaryRadio } from 'src/Components/PrimaryRadio'
import { SelectedLanguage } from 'src/Types/tracks'
import { LabelForGenreOrLanguage } from 'src/Components/LabelForGenreOrLanguage'
import { variables } from 'src/Styled/variables'

type Props = {
  selectedLanguage: SelectedLanguage | null
  targetLanguage?: number | null
  onClick: () => void
  onChange: (id: number) => void
  searchValue: string
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

const SubContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`

const Title = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: ${variables.fontSize14};
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
`

const StyledRadioGroup = styled(Radio.Group)`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 16px;
`
const StyledPrimaryRadio = styled(PrimaryRadio)`
  &.ant-radio-wrapper {
    margin-inline-end: 0px;
  }
  &.ant-radio-wrapper span.ant-radio + * {
    padding-inline-end: 0px;
  }
`
const Text = styled.span`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: ${variables.fontSize14};
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
`

const SubText = styled.span`
  color: ${({ theme }) => theme.color.slateGrey};
  font-size: ${variables.fontSize14};
`
export const LanguagesModalSpotifySelectedLanguage: FC<Props> = (props) => {
  const { selectedLanguage, onClick, onChange, targetLanguage, searchValue } =
    props

  const handleChange = (e: RadioChangeEvent): void => {
    onChange(Number(e.target.value))
  }
  return (
    <Container>
      <LabelForGenreOrLanguage
        title={selectedLanguage?.label}
        onClick={onClick}
        selected
      />

      {selectedLanguage && !searchValue && (
        <SubContainer>
          <Title>Select the type of matching</Title>
          <StyledRadioGroup
            value={String(targetLanguage)}
            onChange={handleChange}
          >
            <StyledPrimaryRadio value='3'>
              <Text>Match selected and other languages</Text>
              <SubText> (Recommended)</SubText>
            </StyledPrimaryRadio>
            <StyledPrimaryRadio value='0'>
              <Text>Match selected language only</Text>
            </StyledPrimaryRadio>
          </StyledRadioGroup>
        </SubContainer>
      )}
    </Container>
  )
}
